import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductViewService } from './../../shared/services/product-view.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ActivityViewHelperService } from '../../shared/services/activity-view-helper.service';
import { AuthService } from "modules/app/services/auth.service";
import { CreateUserAnalyticsService } from "./create-user-analytics.service";

@Injectable()
export class LearnerProductViewResolverService  {
    constructor(
        private productViewService: ProductViewService,
        private appHelperService: AppHelperService,
        private activityViewHelperService: ActivityViewHelperService,
        private authService: AuthService,
        private createUserAnalyticsService: CreateUserAnalyticsService,
        private router: Router,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        const spaceId = route.params.spaceId;
        const productCode = route.params.productCode;
        const classId = route.params.classId;
        const folderId = route.params.folderId;
        
        return this.productViewService.getProductDataForLearner(spaceId, productCode, classId, folderId).toPromise().then((productData) => {
            if (productData && productData.success === false) {
                if(productData.error == 'UA_NOT_PRESENT_ERROR') {
                    let redirectRoute = { url: state.url.split('?')[0], queryParams: route.queryParams };
                    this.createUserAnalyticsService.setUAMetadata(productData.userId, productData.orgId, productData.pubnubEventType, redirectRoute);
                    this.router.navigate(['/learner', route.params.spaceId, 'createUA', 'product', route.params.productCode, 'class', route.params.classId]);
                    return;
                }
                this.appHelperService.showLoaderAndNavigateToDashboard();
                return;
            }
            // NEMO-6677 : navigate away to dashboard as the product is suppressed.
            let bundleDetails = productData['bundleDetails'];
            let product = bundleDetails && bundleDetails.products && bundleDetails.products.find((bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
            let suppressed = this.appHelperService.isProductSuppressed(product, 'hide-learning-path', spaceId);
            if (suppressed) {
                this.appHelperService.navigateToDashboardApp([]);
            }
            return productData;
        });

    }

}
